function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.014.559a2 2 0 011.972 0l4.234 2.4 4.195 2.466a2 2 0 01.986 1.709L22.44 12l-.039 4.866a2 2 0 01-.986 1.709L17.22 21.04l-4.234 2.4a2 2 0 01-1.972 0l-4.234-2.4-4.195-2.466a2 2 0 01-.986-1.709L1.56 12l.039-4.866a2 2 0 01.986-1.709L6.78 2.96l4.234-2.4z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.238 16.265H7.165v-6.186h2.073v6.186zm-1.037-7.03C7.538 9.235 7 8.727 7 8.112c0-.295.127-.578.352-.786A1.25 1.25 0 018.2 7c.318 0 .623.117.849.326.225.208.351.491.351.786 0 .615-.538 1.123-1.2 1.123zm8.797 7.03h-2.069v-3.011c0-.718-.016-1.638-1.078-1.638-1.078 0-1.243.78-1.243 1.586v3.063h-2.07v-6.186h1.987v.844h.03c.276-.486.952-.999 1.961-.999 2.098 0 2.484 1.28 2.484 2.943v3.398h-.002z",
  fill: "#1976D2"
});

function SvgSocialLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgSocialLinkedin;